module.exports = __webpack_public_path__ + "media/images/fake/003-e1dd9463bd53f152c5ab698ac0095ed7.jpg";